import React from 'react'
import InputMaskLib from 'react-input-mask';

import { TextField } from '@mui/material'

export default function InputMask({
    label,
    style,
    placeholder,
    value,
    mask,
    onChange,
    className,
    type = 'text',
    shrink = undefined
}) {
    return (
        <div className={className}>
            <InputMaskLib mask={mask} value={value} onChange={onChange}>
                {(inputProps) => <TextField style={style} type={type} fullWidth label={label} placeholder={placeholder} variant="outlined" {...inputProps} InputLabelProps={shrink == undefined ? {} : { shrink: shrink }} />}
            </InputMaskLib>
        </div>
    )
}
